import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Switch, Tag , Select, InputNumber } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { VEHICLE_STATUS_LIST, VEHICLE_STATUS_LIST_SUCCESS, VEHICLE_STATUS_LIST_ERROR } from './constants';
import { VEHICLE_STATUS_DETAILS, VEHICLE_STATUS_DETAILS_SUCCESS, VEHICLE_STATUS_DETAILS_ERROR } from './constants';
import { ADD_VEHICLE_STATUS_DETAILS, ADD_VEHICLE_STATUS_DETAILS_SUCCESS, ADD_VEHICLE_STATUS_DETAILS_ERROR } from './constants';
import { UPDATE_VEHICLE_STATUS, UPDATE_VEHICLE_STATUS_SUCCESS, UPDATE_VEHICLE_STATUS_ERROR } from './constants';
import { DELETE_VEHICLE_STATUS, DELETE_VEHICLE_STATUS_SUCCESS, DELETE_VEHICLE_STATUS_ERROR } from './constants';
import { ASSIGN_USERS_LIST, ASSIGN_USERS_LIST_SUCCESS, ASSIGN_USERS_LIST_ERROR } from './constants';

import vehiclestatusReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { InfoOutlined,TruckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function VehicleReport() {

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {vehiclestatus : [], users : [] , details: null, pending: false, error: false };
	const [data, dispatch] = useReducer(vehiclestatusReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddVehicleStatusModal, setShowAddVehicleStatusModal] = useState(false);
	const [showEditVehicleStatusModal, setShowEditVehicleStatusModal] = useState(false);
	const [showDeleteVehicleStatusModal, setShowDeleteVehicleStatusModal] = useState(false);
	const [getUserAllocationData, setgetUserAllocationData] = useState(null);
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const envExtendTimeout = process.env.REACT_APP_EXTEND_TIMEOUT == undefined || process.env.REACT_APP_EXTEND_TIMEOUT == 'undefined' ? 180000 : process.env.REACT_APP_EXTEND_TIMEOUT;
	const extendTimeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`) == 'null' ? parseInt(envExtendTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_EXTEND_TIMEOUT`));
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const navigate = useNavigate();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			render: (text) => <span onClick={openEditVehicleStatusModal}>{text}</span>,
		},
		// {
		// 	title: langdata&&langdata.VehicleName?langdata.VehicleName:'Vehicle Name',
		// 	dataIndex: 'activityName',
		// 	key: 'activityName',
			
		// },
		{
			title: langdata&&langdata.VehicleNumber?langdata.VehicleNumber:'Vehicle Number',
			dataIndex: 'vehicleNumber',
			key: 'vehicleNumber',
			
		},
		{
			title: langdata&&langdata.TotalKMs?langdata.TotalKMs:'Total KMs',
			dataIndex: 'travelledDistance',
			key: 'travelledDistance',
			
		},
		{
			title:langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned User',
			dataIndex: 'assignedUser',
			key: 'assignedUser',
			
		},
		{
			title:langdata&&langdata.Allocation?langdata.Allocation:'Allocation',
			dataIndex: 'allocation',
			key: 'allocation',
			
		},
		{
			title:langdata&&langdata.BatteryVoltage?langdata.BatteryVoltage:'Battery Voltage',
			dataIndex: 'batteryVoltage',
			key: 'batteryVoltage',
			
		},
		{
			title:langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number',
			dataIndex: 'imeiNumber',
			key: 'imeiNumber',
			
		},
		{
			title: langdata&&langdata.Status?langdata.Status:'Status',
			dataIndex: 'status',
			key: 'status',
			render: (_,  status ) => (
				
				<>
					{status &&
						<Tag color={status.status === 'Active' ? 'green' :
							'red'}>
							{status.status === 'Active' ? (langdata && langdata.Active ? langdata.Active : 'Active') : (langdata && langdata.Inactive ? langdata.Inactive : 'Inactive')}
						</Tag>}
				</>
			),
			
		},

		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={langdata&&langdata.EditVehicleManagement?langdata.EditVehicleManagement:'Edit vehicle Management'} onClick={()=>openEditVehicleStatusModal(record)}><EditOutlined/></a>
						<a title={langdata&&langdata.DeleteVehicleManagement?langdata.DeleteVehicleManagement:'Delete vehicle Management'} onClick={openDeleteVehicleStatusModal}><DeleteOutlined /></a>
					</Space>
				) : 
					(
						<Space size="middle">
							<a title={langdata&&langdata.EditVehicleManagement?langdata.EditVehicleManagement:'Edit vehicle Management'} onClick={()=>openEditVehicleStatusModal(record)}><EditOutlined/></a>
						</Space>
					)
			)
		}
	];

	const openAddVehicleStatusModal = () => {
		setShowAddVehicleStatusModal(true);
	};

	const cloaseAddVehicleStatusModal = () => {
		setShowAddVehicleStatusModal(false);
		setgetUserAllocationData(null);
		addVehicleStatusFormik.resetForm();
	};

	const openEditVehicleStatusModal = (record) => {
		setShowEditVehicleStatusModal(true);
		getUserallocation(record?.assignedUserId);
	};

	const closeEditVehicleStatusModal = () => {
		setShowEditVehicleStatusModal(false);
		setgetUserAllocationData(null);
		updateVehicleStatusFormik.resetForm();
	};

	const openDeleteVehicleStatusModal = () => {
		setShowDeleteVehicleStatusModal(true);
	};

	//Permission functions 
	

	const loadAssignUser = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/users?&usertypeId[$in][]=4&usertypeId[$in][]=5&usertypeId[$in][]=7&usertypeId[$in][]=13`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {

				if (response.status === 200) {
					dispatch({type:ASSIGN_USERS_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:ASSIGN_USERS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};



	const deleteVehicleStatus = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_VEHICLE_STATUS });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/vehiclemanagement/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_VEHICLE_STATUS_SUCCESS, payload: response});
					setShowDeleteVehicleStatusModal(false);   
					loadVehicleStatus();       
				} else {
					dispatch({type:DELETE_VEHICLE_STATUS_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_VEHICLE_STATUS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteVehicleStatusModal = () => {
		setShowDeleteVehicleStatusModal(false);
	};

	useEffect(() => {
		if(featuresModule.vehicleManagementEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4005);
	}, []);

	useEffect(() => {
		dispatch( { type: VEHICLE_STATUS_LIST });
      
		loadVehicleStatus();
	}, []);


	useEffect(() => {
		dispatch( { type: ASSIGN_USERS_LIST });
      
		loadAssignUser();
	}, []);


	const loadVehicleStatus = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/vehiclemanagement-list?&pipelineId=${parseInt(pipelineId)}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:VEHICLE_STATUS_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:VEHICLE_STATUS_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadVehicleStatusDetails = ((record) => {


		dispatch( { type: VEHICLE_STATUS_DETAILS });
    
		if (!record) {
			dispatch({ type: VEHICLE_STATUS_DETAILS_ERROR });
		} else {
			dispatch({ type: VEHICLE_STATUS_DETAILS_SUCCESS, payload: record });

		}

	});

	

	const addVehicleStatusFormik = useFormik({
		initialValues: {
			addVehiclestatusActivityName : '',
			addVehiclestatusVehicleNumber : 0,
			addVehiclestatustravelledDistance : 0,
			addVehiclestatusAssigneduserId : 0,
			addVehiclestatusStatus : 'Active',
			batteryVoltage : 0,
			imeiNumber : '',
			allocationId : null

		},
		onSubmit: (values) => {

			const name = values.addVehiclestatusActivityName ? values.addVehiclestatusActivityName : '';
			const vehicleNumber = values.addVehiclestatusVehicleNumber ? values.addVehiclestatusVehicleNumber : 0;
			const travelledDistance = values.addVehiclestatustravelledDistance ? values.addVehiclestatustravelledDistance  : 0;
			const assignedUserId = values.addVehiclestatusAssigneduserId ? values.addVehiclestatusAssigneduserId : 0;
			const status = values.addVehiclestatusStatus ? 'Active' : 'Inactive';
			const batteryVoltage = values.batteryVoltage ? values.batteryVoltage : 0;
			const imeiNumber = values.imeiNumber ? values.imeiNumber : '';
			const allocationId = values.allocationId ? values.allocationId : null;

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}


			
			if (!vehicleNumber || vehicleNumber == null || vehicleNumber === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterVehicleNumber ? langdata.PleaseEnterVehicleNumber : 'Please enter vehicle number' });
				return false;
			}

			
			
			if (!travelledDistance || travelledDistance == null || travelledDistance === '') {
				Modal.warning({ title:langdata&&langdata.TotalKMs?langdata.PleaseEnterTotalKMs:'Please enter Total KMs' });
				return false;
			}


			
			if (!assignedUserId || assignedUserId == null || assignedUserId === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' });
				return false;
			}

			
			if (!status || status == null || status === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterStatus?langdata.PleaseEnterStatus:'Please enter status'  });
				return false;
			}

			if (!batteryVoltage || batteryVoltage == null || batteryVoltage === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterBatteryVoltage?langdata.PleaseEnterBatteryVoltage:'Please enter battery voltage' });
				return false;
			}

			if (!imeiNumber || imeiNumber == null || imeiNumber === '') {
				Modal.warning({ title: langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number' });
				return false;
			}

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/vehiclemanagement`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					vehicleNumber : vehicleNumber ,
					travelledDistance : Number(travelledDistance) ,
					assignedUserId :assignedUserId,
					
					allocationId : allocationId ,
					status : status ,
					pipelineId : parseInt( pipelineId ),
					batteryVoltage : Number(batteryVoltage),
					imeiNumber : imeiNumber,

					



				}
			};

			dispatch( { type: ADD_VEHICLE_STATUS_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_VEHICLE_STATUS_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.VehicleManagementAddedSuccessfully ? langdata.VehicleManagementAddedSuccessfully : 'Vehicle management added successfully' });
						setShowAddVehicleStatusModal(false);
						addVehicleStatusFormik.resetForm();
						loadVehicleStatus();
					} else {
						dispatch({type: ADD_VEHICLE_STATUS_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToSaveVehicleManagement ? langdata.UnableToSaveVehicleManagement : 'Unable to save vehicle management' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_VEHICLE_STATUS_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});



	const updateVehicleStatusFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			
								
			updateVehiclestatusActivityName : data.details ? data.details.name : '',
			updateVehiclestatusVehicleNumber :  data.details ? data.details.vehicleNumber : '',
			updateVehiclestatustravelledDistance :  data.details ? data.details.travelledDistance : '',
			updateVehiclestatusAssigneduser : data.details ? data.details.assignedUserId : '',
			updateVehiclestatusStatus :  data.details ? data.details.status === 'Active' ? true : false :  '',
			batteryVoltage : data.details ? data.details.batteryVoltage : 0,
			imeiNumber : data.details ? data.details.imeiNumber : '',
			allocationId : data.details && data.details.allocationId ? data.details.allocationId : null


		},
		onSubmit: (values) => {
			const id = data.details.id;
			const name = values.updateVehiclestatusActivityName ? values.updateVehiclestatusActivityName : '';
			const vehicleNumber = values.updateVehiclestatusVehicleNumber ? values.updateVehiclestatusVehicleNumber : 0;
			const travelledDistance = values.updateVehiclestatustravelledDistance ? values.updateVehiclestatustravelledDistance : 0;
			const assignedUserId = values.updateVehiclestatusAssigneduser ? values.updateVehiclestatusAssigneduser : '';
			const status = values.updateVehiclestatusStatus ?  'Active' : 'Inactive';
			const batteryVoltage = values.batteryVoltage ? values.batteryVoltage : 0;
			const imeiNumber = values.imeiNumber ? values.imeiNumber : '';
			const allocationId = values.allocationId ? values.allocationId : null;

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/vehiclemanagement/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					vehicleNumber : vehicleNumber ,
					travelledDistance : travelledDistance ,
					assignedUserId : assignedUserId ,
					allocationId : allocationId ,
					status : status ,
					pipelineId : parseInt( pipelineId ),
					batteryVoltage : batteryVoltage,
					imeiNumber : imeiNumber,

					

				}
			};

			dispatch( { type: UPDATE_VEHICLE_STATUS });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_VEHICLE_STATUS_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.VehicleManagementUpdatedSuccessfully ? langdata.VehicleManagementUpdatedSuccessfully : 'Vehicle management updated successfully' });
						setShowEditVehicleStatusModal(false);
						updateVehicleStatusFormik.resetForm();
						loadVehicleStatus();
					} else {
						dispatch({type: UPDATE_VEHICLE_STATUS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToUpdateVehicleManagement ? langdata.UnableToUpdateVehicleManagement : 'Unable to update vehicle management' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_VEHICLE_STATUS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.VehicleManagementInfoContent ? langdata.VehicleManagementInfoContent  :  'This module is used to manage vehicles, their assigned users, and monitor vehicle status and related details.'}</p>
		</Card>
	);


	const assigneduserHandler = (value) => {
		addVehicleStatusFormik.setFieldValue('addVehiclestatusAssigneduserId', value);
		addVehicleStatusFormik.setFieldValue('allocationId', null);
		setgetUserAllocationData(null);
		getUserallocation(value);
	};

	const updatevehicleassigneduserhandler = (value) => {
		updateVehicleStatusFormik.setFieldValue('updateVehiclestatusAssigneduser', value);
		updateVehicleStatusFormik.setFieldValue('allocationId', null);
		setgetUserAllocationData(null);
		getUserallocation(value);

	};

	const getUserallocation = (id) =>{

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/userallocation?userId=${id}`,
			timeout: extendTimeout,
			headers: { 
				'Authorization': `Bearer ${authtoken}`   
			}
		};

		axios.request(config)
			.then((response) => {
				if ( response.status === 200) {
					setgetUserAllocationData(response.data.data);
				} else {
					console.log('Unable to fetch user allocation data');
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	
	};


	let regions = [];

	if(getUserAllocationData){
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
			});
		});
	}

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());



	return (
	// permission==='superadmin' || permission === 'admin' ? 

		<>
			<Content>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
						
				}}
				>

					<Col span={12}>
						<Row>
							<Space>
								<TruckOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata&&langdata.VehicleManagement?langdata.VehicleManagement:'Vehicle Management' }</Title>
						</Row>
					</Col>
					
					<Col span={12}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddVehicleStatusModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
										{/* {<Button type="primary" onClick={openAddVehicleStatusModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button>} */}
									</Space>
								</Tooltip>
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata&&langdata.VehicleManagement?langdata.VehicleManagement:'Vehicle Managment' }  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.vehiclestatus.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.vehiclestatus} 
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadVehicleStatusDetails(record);
										}
									};
								}} />
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />
      
			{/* Add Vehicle management Starts */}
			<Modal
				title={ langdata&&langdata.AddVehicleManagement?langdata.AddVehicleManagement:'Add Vehicle Management' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showAddVehicleStatusModal}
				onOk={{cloaseAddVehicleStatusModal}}
				onCancel={cloaseAddVehicleStatusModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseAddVehicleStatusModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addVehicleStatusFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical"  onSubmit={addVehicleStatusFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} >
								<Input name="addVehiclestatusActivityName" onChange={addVehicleStatusFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
							</Form.Item>
						</Col>
					</Row>


					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="vehicleNumber" label={ langdata&&langdata.VehicleNumber?langdata.VehicleNumber:'Vehicle Number'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterVehicleNumber ? langdata.PleaseEnterVehicleNumber:'Please enter vehicle number' }]} >
								<Input name="addVehiclestatusVehicleNumber" onChange={addVehicleStatusFormik.handleChange} placeholder={langdata&&langdata.PleaseEnterVehicleNumber ? langdata.PleaseEnterVehicleNumber:'Please enter vehicle number'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="travelledDistance" label={langdata&&langdata.TotalKMs?langdata.TotalKMs:'Total KMs'} rules={[{ required: false, message: langdata&&langdata.TotalKMs?langdata.PleaseEnterTotalKMs:'Please enter Total KMs' }]} >
								<InputNumber name="addVehiclestatustravelledDistance" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addVehicleStatusFormik.setFieldValue('addVehiclestatustravelledDistance', value)} 
									placeholder={langdata&&langdata.TotalKMs?langdata.PleaseEnterTotalKMs:'Please enter Total KMs'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="assignedUser" label={ langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned user'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' }]} >
								<Select name="addVehiclestatusAssigneduserId" onChange={(value) => assigneduserHandler(value)} placeholder={ langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user'} 
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									options={data.users} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' }]} >
								<Select name="allocationId"
									showSearch 
									disabled={getUserAllocationData && getUserAllocationData.length === 0 || getUserAllocationData === null} onChange={(value) => addVehicleStatusFormik.setFieldValue('allocationId', value)} placeholder={getUserAllocationData === null ? langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : getUserAllocationData && getUserAllocationData.length > 0 ?  langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : langdata&&langdata.Thereisnoallocationforthisuser?langdata.Thereisnoallocationforthisuser:'There is no allocation for this user'} 
									options={regions}
									optionFilterProp="children"
									filterOption={filterOption}
									value={addVehicleStatusFormik.values.allocationId} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batteryVoltage" label={langdata&&langdata.BatteryVoltage?langdata.BatteryVoltage:'Battery Voltage'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterBatteryVoltage?langdata.PleaseEnterBatteryVoltage:'Please enter battery voltage' }]} >
								<InputNumber name="batteryVoltage" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									step={0.1}
									min={0}
									onChange={(value) => addVehicleStatusFormik.setFieldValue('batteryVoltage', value)} 
									placeholder={langdata&&langdata.BatteryVoltage?langdata.PleaseEnterBatteryVoltage:'Please enter battery voltage'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="imeiNumber" label={langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number' }]} >
								<Input name="imeiNumber" 
									style={
										{
											width : '100%'
										}
									}
									stringMode
									
									onChange={addVehicleStatusFormik.handleChange}
									placeholder={langdata&&langdata.IMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="status" label={ langdata&&langdata.Status?langdata.Status:'Status'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterStatus?langdata.PleaseEnterStatus:'Please enter status' }]} >
								<Switch checkedChildren = {langdata && langdata.Active ? langdata.Active : 'Active'} unCheckedChildren = {langdata && langdata.Inactive ? langdata.Inactive : 'Inactive'}  name="addVehiclestatusStatus" 
									onChange={(value) => addVehicleStatusFormik.setFieldValue('addVehiclestatusStatus', value)} 
									defaultChecked
									placeholder={ langdata&&langdata.PleaseEnterStatus?langdata.PleaseEnterStatus:'Please enter status'} />
							</Form.Item>
						</Col>
					</Row>
                                            
				</Form>
			</Modal>
			{/* Add Vehicle management Ends */}

			{/* Edit Vehicle management Starts */}
			<Modal
				
				title={ langdata&&langdata.EditVehicleManagement?langdata.EditVehicleManagement:'Edit Vehicle Management'}
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showEditVehicleStatusModal}
				onOk={{closeEditVehicleStatusModal}}
				onCancel={closeEditVehicleStatusModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeEditVehicleStatusModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						<Button type="primary" onClick={updateVehicleStatusFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> 
					</Space>
				]}
				width={800}
			>

				<Form layout="vertical" onSubmit={updateVehicleStatusFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
								<Input name="updateVehiclestatusActivityName" onChange={updateVehicleStatusFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} 
									value={updateVehicleStatusFormik.values.updateVehiclestatusActivityName} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={  langdata&&langdata.VehicleNumber?langdata.VehicleNumber:'Vehicle Number'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterVehicleNumber?langdata.PleaseEnterVehicleNumber:'Please enter the vehicle number'}]} required>
								<Input name="updateVehiclestatusVehicleNumber" 
									onChange={updateVehicleStatusFormik.handleChange} 
									placeholder={langdata&&langdata.PleaseEnterVehicleNumber?langdata.PleaseEnterVehicleNumber:'Please enter the vehicle number'} 
									value={updateVehicleStatusFormik.values.updateVehiclestatusVehicleNumber} />
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="travelledDistance" label={langdata&&langdata.TotalKMs?langdata.TotalKMs:'Total KMs'} rules={[{ required: false, message: langdata&&langdata.TotalKMs?langdata.PleaseEnterTotalKMs:'Please enter Total KMs' }]} >
								<InputNumber name="updateVehiclestatustravelledDistance" 
									style={
										{
											width : '100%'
										}
									}
								
									min={0}
									step={0.1}
									onChange={(value) => updateVehicleStatusFormik.setFieldValue('updateVehiclestatustravelledDistance', value)} 
									placeholder={langdata&&langdata.TotalKMs?langdata.PleaseEnterTotalKMs:'Please enter the  Total KMs'} 
									defaultValue ={updateVehicleStatusFormik.values.updateVehiclestatustravelledDistance}/>
							</Form.Item>
						</Col>
					</Row>

					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="assignedUser" label={ langdata&&langdata.AssignedUser?langdata.AssignedUser:'Assigned user'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user' }]} >
								<Select name="updateVehiclestatusAssigneduser" onChange={(value) => updatevehicleassigneduserhandler(value)} 
									placeholder={ langdata&&langdata.PleaseEnterAssignedUser?langdata.PleaseEnterAssignedUser:'Please enter assigned user'} 
									options={data.users}
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									defaultValue={data.details && data.details.assignedUser} 
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={ langdata&&langdata.Allocation?langdata.Allocation:'Allocation'} rules={[{ required: true, message: langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' }]} >
								<Select name="allocationId" 
									disabled={getUserAllocationData && getUserAllocationData.length === 0 || getUserAllocationData === null} onChange={(value) => updateVehicleStatusFormik.setFieldValue('allocationId', value)} placeholder={getUserAllocationData === null ? langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : getUserAllocationData && getUserAllocationData.length > 0 ?  langdata&&langdata.PleaseEnterAllocation?langdata.PleaseEnterAllocation:'Please enter allocation' : langdata&&langdata.Thereisnoallocationforthisuser?langdata.Thereisnoallocationforthisuser:'There is no allocation for this user'} 
									options={regions}
									showSearch
									optionFilterProp="children"
									filterOption={filterOption}
									value={updateVehicleStatusFormik.values.allocationId}
									defaultValue={updateVehicleStatusFormik.values.allocationId} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="batteryVoltage" label={langdata&&langdata.BatteryVoltage?langdata.BatteryVoltage:'Battery Voltage'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterBatteryVoltage?langdata.PleaseEnterBatteryVoltage:'Please enter battery voltage' }]} >
								<InputNumber name="batteryVoltage" 
									style={
										{
											width : '100%'
										}
									}
								
									min={0}
									step={0.1}
									onChange={(value) => updateVehicleStatusFormik.setFieldValue('batteryVoltage', value)} 
									placeholder={langdata&&langdata.BatteryVoltage?langdata.PleaseEnterBatteryVoltage:'Please enter battery voltage'} 
									defaultValue ={updateVehicleStatusFormik.values.batteryVoltage}/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="imeiNumber" label={langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterIMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number' }]} >
								<Input name="imeiNumber" 
									style={
										{
											width : '100%'
										}
									}
									onChange={updateVehicleStatusFormik.handleChange} 
									placeholder={langdata&&langdata.IMEINumber?langdata.PleaseEnterIMEINumber:'Please enter IMEI number'} 
									defaultValue ={updateVehicleStatusFormik.values.imeiNumber}/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata&&langdata.Status?langdata.Status:'Status'} rules={[{ required: false, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} >
								<Switch name="updateVehiclestatusStatus"
									
									onChange={(value) => updateVehicleStatusFormik.setFieldValue('updateVehiclestatusStatus', value)} 
									checked = {updateVehicleStatusFormik.values.updateVehiclestatusStatus}
									checkedChildren = {langdata && langdata.Active ? langdata.Active : 'Active'} unCheckedChildren = {langdata && langdata.Inactive ? langdata.Inactive : 'Inactive'}  value={updateVehicleStatusFormik.values.updateSpeedClassificationActivityName} />
							</Form.Item>
						</Col>
					</Row> 
                        
                        

                        
				</Form>
			</Modal>
			{/* Edit Vehicle management Ends */}

			{/* Delete  Vehicle management Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteVehicleStatusModal} onOk={deleteVehicleStatus} onCancel={closeDeleteVehicleStatusModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.ConfirmDeleteVehicleManagement?langdata.ConfirmDeleteVehicleManagement:'Are you sure you want to delete this Vehicle Management?' }</Col>
				</Row>
			</Modal>
			{/* Delete  Vehicle management Ends */}
		</> 
	);
}